import { Pipe, PipeTransform } from '@angular/core';
import { Subscription } from 'src/app/api/subscription';

import { PlansService } from 'src/app/components/plans/plans.service';

@Pipe({
  name: 'subscriptionDescription',
  standalone: false,
})
export class SubscriptionDescriptionPipe implements PipeTransform {
  constructor(public plansService: PlansService) {}

  _getPeriod(subscription: Subscription) {
    if (subscription.billing_period > 1) {
      return (
        subscription.billing_period +
        ' ' +
        (subscription.billing_period_unit === 'month' ? 'Month' : 'Year')
      );
    } else {
      return subscription.billing_period_unit === 'month'
        ? 'Monthly'
        : 'Annual';
    }
  }

  transform(subscription: Subscription): string {
    if (
      !subscription ||
      Object.keys(subscription).length === 0 ||
      !subscription.plan
    ) {
      return '';
    }

    // var prefix = subscription.plan_quantity > 1 ? subscription.plan_quantity + ' x ' : '';
    let prefix =
      subscription.plan.quantity > 1 ? subscription.plan.quantity + ' x ' : '';
    const plan = this.plansService.getPlanById(subscription.plan.item_price_id);
    if (plan) {
      let name = plan.name;

      // Show `1` plan_quantity for Per Display subscriptions
      if (
        plan &&
        this.plansService.isVolumePlan(plan) &&
        subscription.plan.quantity > 0
      ) {
        prefix = subscription.plan.quantity + ' x ';
      }

      var period = this._getPeriod(subscription);

      if (this.plansService.isVolumePlan(plan)) {
        name = name + ' ' + period + ' Plan';
      } else {
        name = name + ' Plan ' + period;
      }

      return prefix + name;
    } else {
      return subscription.plan.item_price_id;
    }
  }
}
